import axios from 'axios';
import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import DataTable from '../components/DataTable';

const ListarProgramas = ({ refresh }) => {
  const [programas, setProgramas] = useState([]);
  const navigate = useNavigate(); // Para redirigir

  const getData = useCallback(async () => {
    try {
      const { data } = await axios.get("/api/programas/listall/");
      const programasConFunciones = data.programas.map((programas) => ({
        ...programas,
        funciones: (
          <div className="d-flex gap-2">

            <button
              className="btn btn-warning"
              style={{ width: "30px", height: "30px", padding: "0" }}
              onClick={() => navigate(`/institucional/programas/${programas._id}`)}
              title='Editar Programa'
            >
              <i className="fa-solid fa-pen-to-square"></i>
            </button>

            <button
              className="btn btn-success"
              style={{ width: "30px", height: "30px", padding: "0" }}
              onClick={() =>
                navigate(`/institucional/programas/guias/registrar/${programas._id}/${programas.codPrograma}`)}
                title='Registrar Guía del Programa'
            >
              <i className="fa-solid fa-file-circle-plus"></i>
            </button>

            <button
              className="btn btn-outline-primary"
              style={{ width: "30px", height: "30px", padding: "0" }}
              onClick={() =>
                navigate(`/institucional/programas/guias/listarguias/${programas.codPrograma}`)}
                title='Listar Guías del Programa'
            >
              <i className="fa-solid fa-list-check"></i>
            </button>

            <button
              className="btn btn-danger"
              style={{ width: "30px", height: "30px", padding: "0" }}
              onClick={() => deletePrograma(programas._id)}
              title="Eliminar Programa"
            >
              <i className="fa-solid fa-trash"></i>
            </button>

          </div>
        ),
      }));
      setProgramas(programasConFunciones.reverse());
    } catch (error) {
      console.error("Error al cargar los programas:", error.message);
    }
    // eslint-disable-next-line
  }, [navigate]);

  useEffect(() => {
    getData();
  }, [getData, refresh]);

  const deletePrograma = async (id) => {
    try {
      Swal.fire({
        title: '¿Está seguro?',
        text: '¡No podrá revertir este proceso!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sí, eliminar!',
      }).then(async (result) => {
        if (result.isConfirmed) {
          const { data } = await axios.delete(`/api/programas/delete/${id}`);
          getData();
          Swal.fire({
            icon: 'success',
            title: data.message,
            showConfirmButton: false,
            timer: 1500,
          });
        }
      });
    } catch (error) {
      console.error('Error al eliminar el programa:', error.message);
      Swal.fire('Error', 'No se pudo eliminar el programa.', 'error');
    }
  };

  const columns = React.useMemo(() => [
    { Header: 'Codigo', accessor: 'codPrograma' },
    { Header: 'Programa', accessor: 'nombrePrograma' },
    { Header: 'Estado', accessor: 'estadoPrograma' },
    { Header: 'Nivel', accessor: 'nivelPrograma' },
    { accessor: 'funciones' },
  ], []);

  return (
   <div className="container-fluid py-1 px-0 shadow-lg rounded-4 bg-light mt-5">
      <h1>Lista de Programas de Formación</h1>
      {Array.isArray(programas) && programas.length > 0 ? (
        <DataTable columns={columns} data={programas} />
      ) : (
        <p>Cargando programas...</p>
      )}
    </div>
  );
};

export default ListarProgramas;
